<template>
  <div>
    <c-row>
      <c-col class="u-text-center"><i class="icon-upload2 u-fs-32 u-color-primary"/></c-col>
    </c-row>
    <c-row>
      <c-col class="u-text-center">Drop files to upload<br/><i>or</i></c-col>
    </c-row>
    <c-row>
      <c-col class="u-text-center">
        <file-upload
          class="btn btn-primary dropdown-toggle"
          input-id="multiproc_upload"
          :post-action="postAction"
          :put-action="putAction"
          :extensions="extensions"
          :accept="accept"
          :multiple="multiple"
          :directory="directory"
          :size="size || 0"
          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
          :headers="headers"
          :data="data"
          :drop="drop"
          :drop-directory="dropDirectory"
          :add-index="addIndex"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          @input="onFiles"
          ref="upload"

          chunk-enabled
          :chunk="{
            action: chunkAction,
            headers: chunkHeaders,
            minSize: 1024 * 1024 * 15,
            maxActive: 3,
            maxRetries: 5,
            startBody: chunksBody,
            uploadBody: chunksBody,
            finishBody: chunksBody
          }">
          <i class="icon-plus"></i>
          Select files
        </file-upload>
      </c-col>
    </c-row>
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Drop files to upload</h3>
    </div>
    <div>
      <span v-if="files.length">
        <c-row>
          <c-col>
            <a href="#" @click.prevent="clearFiles()"><i class="icon-reset u-color-success"></i></a>
          </c-col>
        </c-row>
        <c-row v-for="(file,index) in files" :key="file.id">
            <c-col span="21"><span class="u-block">{{ file.name }}</span></c-col>
            <c-col>
                <span v-if="file.error"><i class="icon-notification2 u-color-danger u-ml-5 u-fs-12"
                                           v-tooltip="file.error"></i></span>
                <span v-else-if="file.success"><i class="icon-checkmark u-color-success u-ml-5 u-fs-12"></i></span>
                <span v-else-if="file.active"><i class="i-spinner u-ml-5 u-fs-12"></i></span>
                <span v-else>
                    <a href="#" @click.prevent="$refs.upload.remove(file)"><i
                      class="icon-minus-circle u-color-danger u-ml-5 u-fs-12"></i></a>
                </span>
            </c-col>
        </c-row>
      </span>
    </div>
    <FileUploadRequestProperties ref="furp"></FileUploadRequestProperties>
  </div>
</template>
<script>
/*
Component from https://lian-yue.github.io/vue-upload-component/#/en/
*/
import {mapState} from 'vuex'
import FileUploadRequestProperties from './FileUploadRequestProperties'

export default {
  components: {
    FileUploadRequestProperties
  },

  computed: {
    ...mapState('auth', ['clientCode']),
    ...mapState('client', ['requestProperties'])
  },

  data () {
    return {
      isDataLoaded: false,

      files: [],
      accept:
        'image/png,image/gif,image/jpeg,image/webp,image/tiff,application/pdf,text/csv,application/xml,application/json',
      extensions: 'gif,jpg,jpeg,png,webp,tiff,pdf,csv,xml,json',
      minSize: 1,
      size: 0, // 1024 * 1024 * 30,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: false,
      addIndex: true,
      thread: 1,
      name: 'file',
      postAction: process.env.API + 'upload/post',
      chunkAction: process.env.API + 'upload/chunk',
      chunkMinSize: 15,
      chunkHeaders: {
        Authorization: 'Basic xxx'
      },
      chunksBody: {},
      putAction: '',
      headers: {
        Authorization: 'Basic xxx'
      },
      data: {
        _csrf_token: 'xxxxxx'
      },

      autoCompress: 1024 * 1024,
      uploadAuto: false,

      editFile: {
        show: false,
        name: ''
      }
    }
  },

  methods: {
    clearFiles () {
      let n = []
      this.files.forEach(element => {
        if (!element.success && !element.error) {
          n.push(element)
        }
      })
      this.files = n
    },

    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file

        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
      }
    },

    onFiles (files) {
      // see if there are any files without proper Data structure (to include the required properties); if so,
      // mark the file as inactive and display an input dialog
      // otherwise, activate the file and continue
      let props = this.requestProperties
      let requiresInput = false
      for (const p of props) {
        if (p.is_visible && p.allows_manual_input) {
          requiresInput = true
          break
        }
      }
      if (!requiresInput) {
        for (const f of files) {
          if (!f.success && !f.error && !f.active) {
            // f.active = true
            this.$refs.upload.update(f, {active: true})
          }
        }
      } else {
        // display the dialog to specify the inputs
        this.$refs.furp.show(files, props, this.$refs.upload)
      }
    },

    // add, update, remove File Event
    inputFile (newFile, oldFile) {
      if (newFile) {
        newFile.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
        newFile.headers['client'] = this.clientCode
        newFile.data['client'] = this.clientCode

        this.chunkHeaders['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
        this.chunkHeaders['client'] = this.clientCode

        this.chunksBody['client'] = this.clientCode
      }

      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },

    alert (message) {
      alert(message)
    },

    onEditFileShow (file) {
      this.editFile = {...file, show: true}
      this.$refs.upload.update(file, {error: 'edit'})
    },

    onEditorFile () {
      if (!this.$refs.upload.features.html5) {
        this.alert('Your browser does not support')
        this.editFile.show = false
        return
      }

      let data = {
        name: this.editFile.name
      }
      if (this.editFile.cropper) {
        let binStr = atob(
          this.editFile.cropper
            .getCroppedCanvas()
            .toDataURL(this.editFile.type)
            .split(',')[1]
        )
        let arr = new Uint8Array(binStr.length)
        for (let i = 0; i < binStr.length; i++) {
          arr[i] = binStr.charCodeAt(i)
        }
        data.file = new File([arr], data.name, {type: this.editFile.type})
        data.size = data.file.size
      }
      this.$refs.upload.update(this.editFile.id, data)
      this.editFile.error = ''
      this.editFile.show = false
    }
  },
  created () {
    // this.headers['Authorization'] = window.sessionStorage.getItem('token')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Upload.vue